module.exports = {
  DESKTOP: {
    '0.2.149': 'beta',
    '0.3.154': 'beta',
    '0.4.154': 'beta',
    '1.0.154': 'stable',
    '2.0.172': 'stable',
    '3.0.195': 'stable',
    '4.0.249': 'stable',
    '4.1.249': 'stable',
    '5.0.375': 'stable',
    '6.0.472': 'stable',
    '7.0.517': 'stable',
    '8.0.552': 'stable',
    '9.0.597': 'stable',
    '10.0.648': 'stable',
    '11.0.696': 'stable',
    '12.0.742': 'stable',
    '13.0.782': 'stable',
    '14.0.835': 'stable',
    '15.0.874': 'stable',
    '16.0.912': 'stable',
    '17.0.963': 'stable',
    '18.0.1025': 'stable',
    '19.0.1084': 'stable',
    '20.0.1132': 'stable',
    '21.0.1180': 'stable',
    '22.0.1229': 'stable',
    '23.0.1271': 'stable',
    '24.0.1312': 'stable',
    '25.0.1364': 'stable',
    '26.0.1410': 'stable',
    '27.0.1453': 'stable',
    '28.0.1500': 'stable',
    '29.0.1547': 'stable',
    '30.0.1599': 'stable',
    '31.0.1650': 'stable',
    '32.0.1700': 'stable',
    '33.0.1750': 'stable',
    '34.0.1847': 'stable',
    '35.0.1916': 'stable',
    '36.0.1985': 'stable',
    '37.0.2062': 'stable',
    '38.0.2125': 'stable',
    '39.0.2171': 'stable',
    '40.0.2214': 'stable',
    '41.0.2272': 'stable',
    '42.0.2311': 'stable',
    '43.0.2357': 'stable',
    '44.0.2403': 'stable',
    '45.0.2454': 'stable',
    '46.0.2490': 'stable',
    '47.0.2526': 'stable',
    '48.0.2564': 'stable',
    '49.0.2623': 'stable',
    '50.0.2661': 'stable',
    '51.0.2704': 'stable',
    '52.0.2743': 'stable',
    '53.0.2785': 'stable',
    '54.0.2840': 'stable',
    '55.0.2883': 'stable',
    '56.0.2924': 'stable',
    '57.0.2987': 'stable',
    '58.0.3029': 'stable',
    '59.0.3071': 'stable',
    '60.0.3112': 'stable',
    '61.0.3163': 'stable',
    '62.0.3202': 'stable',
    '63.0.3239': 'stable',
    '64.0.3282': 'stable',
    '65.0.3325': 'stable',
    '66.0.3359': 'stable',
    '67.0.3396': 'stable',
    '68.0.3440': 'stable',
    '69.0.3497': 'stable',
    '70.0.3538': 'stable',
    '71.0.3578': 'stable',
    '72.0.3626': 'stable',
    '73.0.3683': 'stable',
    '74.0.3729': 'stable',
    '75.0.3770': 'stable',
    '76.0.3809': 'stable',
    '77.0.3865': 'stable',
    '78.0.3904': 'stable',
  },
  MOBILE: {
    '16.0.912': 'beta',
    '18.0.1025': 'stable',
    '25.0.1364': 'stable',
    '27.0.1453': 'stable',
    '29.0.1547': 'stable',
    '30.0.1599': 'stable',
    '31.0.1650': 'stable',
    '32.0.1700': 'stable',
    '33.0.1750': 'stable',
    '34.0.1847': 'stable',
    '35.0.1916': 'stable',
    '36.0.1985': 'stable',
    '37.0.2062': 'stable',
    '38.0.2125': 'stable',
    '39.0.2171': 'stable',
    '40.0.2214': 'stable',
    '41.0.2272': 'stable',
    '42.0.2311': 'stable',
    '43.0.2357': 'stable',
    '44.0.2403': 'stable',
    '45.0.2454': 'stable',
    '46.0.2490': 'stable',
    '47.0.2526': 'stable',
    '48.0.2564': 'stable',
    '49.0.2623': 'stable',
    '50.0.2661': 'stable',
    '51.0.2704': 'stable',
    '52.0.2743': 'stable',
    '53.0.2785': 'stable',
    '54.0.2840': 'stable',
    '55.0.2883': 'stable',
    '56.0.2924': 'stable',
    '57.0.2987': 'stable',
    '58.0.3029': 'stable',
    '59.0.3071': 'stable',
    '60.0.3112': 'stable',
    '61.0.3163': 'stable',
    '62.0.3202': 'stable',
    '63.0.3239': 'stable',
    '64.0.3282': 'stable',
    '65.0.3325': 'stable',
    '66.0.3359': 'stable',
    '67.0.3396': 'stable',
    '68.0.3440': 'stable',
    '69.0.3497': 'stable',
    '70.0.3538': 'stable',
    '71.0.3578': 'stable',
    '72.0.3626': 'stable',
    '73.0.3683': 'stable',
    '74.0.3729': 'stable',
    '75.0.3770': 'stable',
    '76.0.3809': 'stable',
    '77.0.3865': 'stable',
    '78.0.3904': 'stable',
  },
};
